import React from "react";
import styles from "./InfoWithIcon.module.scss";

export default function InfoWithIcon({ svgIcon, primaryText, secondaryText }) {
  return (
    <div className={styles.container}>
      <div className={styles.icon}>{svgIcon}</div>
      <div className={styles.text}>
        <h3>{primaryText}</h3>
        <p>{secondaryText}</p>
      </div>
    </div>
  );
}
